import { $, $$ } from '@3pc/dom';
import { Accordion } from '@3pc/accordion';
// import { uniqueId } from 'src/shared/js/utils/helper';
import CustomLightbox from 'src/shared/js/modules/lightbox';

const textmedia = $$('.textmedia__text');

const initReadMore = container => {
  const handler = $('.textmedia__readmore-btn', container);
  const target = $('.textmedia__readmore-text', container);
  const targetInner = $('.textmedia__readmore-text-inner', container);

  if (!handler || !target || !targetInner) return;

  const accordion = new Accordion({
    target,
    targetInner,
    handler,
    easing: 'easeInOutQuart',
    duration: 500,
    initOpened: false,
    openClassName: 'is-open',
  });
  accordion.init();
};

textmedia.length &&
  textmedia.forEach(item => {
    return initReadMore(item);
  });

const toggles = $$('[class$="__lightbox-toggle');

// for each toggle create a new lightbox instance
toggles.length &&
  toggles.forEach(toggle => {
    const lightbox = new CustomLightbox(toggle);
    lightbox.init();
  });
